import * as angular from 'angular';
import * as _ from 'lodash';

import { PropertyType, IFrequency, ContextualField, AlarmLevel, KeyValuePair } from '../../../models';
import {
    AlarmCategories,
    frequencyErrors,
    GroupGuids,
    GroupTypes,
    IsDisabledField,
    Name,
    periodValidationRequired,
} from '../../../common/helpers/contextual/predefinedContextualFields';

const alarms: KeyValuePair<any, string>[] = [];
for (const key of Object.keys(AlarmLevel)) {
    const parsed = parseInt(key);
    if (!isNaN(parsed)) {
        alarms.push({ key: parsed, value: AlarmLevel[key] });
    }
}

export const triggerProperties: { [key: number]: ContextualField[] } = {
    0: [
        angular.copy(Name),
        {
            label: 'Frequency',
            modelName: 'frequency',
            propertyName: 'frequencyProperty',
            propertyType: PropertyType.Frequency,
            icon: 'fa-clock-o',
            errorName: 'frequencyPropertyInterval',
            messages: frequencyErrors,
            extraData: {
                allowFrequencyIntervalZero: false
            }
        },
        {
            label: 'Offset',
            modelName: 'offset',
            propertyName: 'offsetProperty',
            propertyType: PropertyType.Frequency,
            icon: 'fa-hourglass-start',
            errorName: 'offsetPropertyInterval',
            messages: frequencyErrors,
            extraData: {
                frequencyValidationRules: [periodValidationRequired,
                    {
                        key: 'minOrZero',
                        isValid: (frequency: IFrequency) => {
                            return frequency.interval === null
                                || frequency.interval === undefined
                                || (frequency.interval >= 0);
                        }
                    }],
                allowFrequencyIntervalZero: true
            }
        },
        {
            label: 'Launch missed tasks',
            modelName: 'hasLaunchMissedTasks',
            propertyName: 'hasLaunchMissedTasksProperty',
            propertyType: PropertyType.Boolean,
            icon: 'fa-refresh'
        },
        angular.copy(IsDisabledField)
    ],
    1: [
        angular.copy(Name),
        {
            modelName: 'qualityIssues',
            propertyType: PropertyType.MultiQuality,
            icon: 'fa-exclamation-circle',
            label: 'Quality issues',
            propertyName: 'qualityIssuesProperty',
            extraData: {
            }
        },
        angular.copy(GroupGuids),
        angular.copy(GroupTypes),
        angular.copy(IsDisabledField)
    ],
    3: [
        angular.copy(Name),
        {
            label: 'Severities',
            modelName: 'alarmLevels',
            propertyName: 'alarmLevelsProperty',
            propertyType: PropertyType.MultiSelect,
            icon: 'fa-bell',
            extraData: {
                options: alarms
            }
        },
        angular.copy(GroupGuids),
        angular.copy(GroupTypes),
        angular.copy(AlarmCategories),
        angular.copy(IsDisabledField)
    ]
};